import { useProjectQuery } from "@gql/sites-api/graphql";
import { routedClient, LandTechEndpoints } from "react-migration/lib/persistence/apollo";
import { siteStore } from "src/js/stores/site/store";
import { useSnapshot } from "valtio/react";

type UseSelectedProjectQueryParams = {
  forceUpdateLastOpenedDate: boolean;
};

export function useSelectedProjectQuery(params?: UseSelectedProjectQueryParams) {
  const { forceUpdateLastOpenedDate = false } = params ?? {};
  const { selectedProjectId } = useSnapshot(siteStore);

  const { data, ...queryState } = useProjectQuery({
    variables: {
      projectId: selectedProjectId!,
    },
    skip: !selectedProjectId,
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Sites,
    },
    // If we want to update the last opened date, we need to hit the network.
    fetchPolicy: forceUpdateLastOpenedDate ? "cache-and-network" : "cache-first",
  });

  return {
    selectedProject: data?.project,
    ...queryState,
  };
}
